import {BookingMutationActionBase} from "../booking-mutation-action-base";
import {BookingModel} from "../../booking.model";
import {JourneyModel} from "../../journey/journey.model";
import {
    IDotRezPartialBookingSessionData
} from "../../../../dot-rez-api/data-contracts/booking/dot-rez-booking-session-data.interface";
import {IBundleSsrUpgradePair} from "../../bundle/bundle-ssr-upgrade.model.interface";
import {createJourneySellBundleRequests} from "./sell-bundle.helpers";

export abstract class ResellJourneyBundleMutation extends BookingMutationActionBase{
    constructor(booking: BookingModel,
                protected readonly bundleCodeToResell: string) {
        super(booking)
    }

    abstract get journey(): JourneyModel;

    async _runMutation(): Promise<IDotRezPartialBookingSessionData> {

        const bundle = this.journey.bundlesAvailability.find(b => b.bundleCode === this.bundleCodeToResell);
        if(!bundle) {
            throw new Error(`There is no available bundle with code ${this.bundleCodeToResell} for journey ${this.journey.journeyKey}`);
        }

        let sellBundleForOneJourneyRequest = this._createJourneySellBundleRequest(this.journey, []);

        await this.session.sellBundle({
            ssrKeysToRemove: sellBundleForOneJourneyRequest.ssrKeysToRemove.distinct(key => key),
            journeys: sellBundleForOneJourneyRequest.requests //TODO check for child bundle
        });

        const bookingState = await this.session.bookingStateQueryBuilder().useBookingData().getBookingState();

        const bundleSsrsUpgradesPairs = this.journey.getInitialBundleSsrsUpgradesPairs();

        if(bundleSsrsUpgradesPairs.length === 0) {
            return bookingState;
        }

        this.booking.updateBookingSessionData(bookingState);

        sellBundleForOneJourneyRequest = this._createJourneySellBundleRequest(this.journey, bundleSsrsUpgradesPairs);
        await this.session.sellBundle({
            ssrKeysToRemove: sellBundleForOneJourneyRequest.ssrKeysToRemove.distinct(key => key),
            journeys: sellBundleForOneJourneyRequest.requests //TODO check for child bundle
        });

        return await this.session.bookingStateQueryBuilder().useBookingData().getBookingState();

    }

    protected _createJourneySellBundleRequest(journey: JourneyModel, bundleSsrsUpgradesPairs: IBundleSsrUpgradePair[]) {

        return createJourneySellBundleRequests(this.bundleCodeToResell, journey, bundleSsrsUpgradesPairs);
    }
}